


  import dep0 from "@glimmer/component/-embroider-implicit-modules.js";
  import dep1 from "ember-async-data/-embroider-implicit-modules.js";
  import dep2 from "ember-modifier/-embroider-implicit-modules.js";
  import dep3 from "ember-primitives/-embroider-implicit-modules.js";
  import dep4 from "ember-repl/-embroider-implicit-modules.js";
  import dep5 from "ember-resources/-embroider-implicit-modules.js";
  import dep6 from "kolay/-embroider-implicit-modules.js";
  import dep7 from "@nullvoxpopuli/limber-shared/-embroider-implicit-modules.js";
  import dep8 from "limber-ui/-embroider-implicit-modules.js";
  import dep9 from "reactiveweb/-embroider-implicit-modules.js";
  import dep10 from "@ember/test-helpers/-embroider-implicit-modules.js";
  import dep11 from "@ember/test-waiters/-embroider-implicit-modules.js";
  import dep12 from "@fortawesome/ember-fontawesome/-embroider-implicit-modules.js";
  import dep13 from "ember-modify-based-class-resource/-embroider-implicit-modules.js";
  import dep14 from "ember-page-title/-embroider-implicit-modules.js";
  import dep15 from "ember-qunit/-embroider-implicit-modules.js";
  import dep16 from "ember-source/-embroider-implicit-modules.js";


export default Object.assign({},
    dep0,
    dep1,
    dep2,
    dep3,
    dep4,
    dep5,
    dep6,
    dep7,
    dep8,
    dep9,
    dep10,
    dep11,
    dep12,
    dep13,
    dep14,
    dep15,
    dep16,
  {
  }
);
